module.exports = __webpack_public_path__ + "img/icon-letter-s.178c93bd.svg";